import Icon from "@/icons";
import { useState, useEffect } from "react";

export default function EmailVerify() {
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get('key');
    const date = urlParams.get('date');
    const email = urlParams.get('email');
    const [errorMsg, setError] = useState("");
    useEffect(() => {
        if (!key || !date || !email) {
            setError("Invalid Email Verification Link");
            return;
        }
        verifyEmail();
    }, []);

    const verifyEmail = async () => {
        const response = await fetch(`__SITE_BASE__/api/me/email/verify`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ key, email })
        });
        const data = await response.json();
        if (data.message) return setError(data.message);
    }

    if (errorMsg) return error({ msg: errorMsg });
    return (
        <div className="h-screen  px-2 sm:px-0 w-full flex items-center justify-center bg-gradient-to-b from-brand-green/20 to-brand-darkest">
            <div className="flex items-center">
                <div className="rounded-r-lg sm:rounded-r-none sm:rounded-l-lg gap-2 mt-12 flex-col bg-brand-dark text-white h-full px-2 sm:px-32 py-2 w-auto flex items-center justify-center">
                    
                    <div className="flex flex-col gap-2 items-center bg-gradient-to-tr from-green-500 to-green-600 rounded-full w-16 h-16 justify-center">  
                    <Icon name="verified" size='32' />
                    </div>
                    <div className="flex flex-col gap-2 items-center">
                        <p className="text-2xl font-bold text-center">
                            Email Verified
                        </p>
                    </div>
                    <div className="flex gap-2 items-center mt-4 font-bold mb-8">
                        <button className="bg-brand-green text-white px-4 py-2 rounded-lg" onClick={() => window.location.href = '/'}>Go Home</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const error = ({ msg }: { msg?: string }) => {
    return (
        <div className="h-screen px-2 sm:px-0 w-full flex items-center justify-center bg-gradient-to-b from-brand-green/20 to-brand-darkest">
            <div className="flex items-center">
                <div className="rounded-r-lg sm:rounded-r-none sm:rounded-l-lg gap-2 mt-8 flex-col bg-brand-dark text-white h-full px-2 sm:px-32 py-2 w-auto flex items-center justify-center">
                    
                    <div className="flex flex-col gap-2 items-center bg-gradient-to-tr from-red-500 to-red-600 rounded-full w-16 h-16 justify-center">  
                    <Icon name="exclamation" size='32' />
                    </div>
                    <div className="flex flex-col gap-2 items-center">
                        <p className="text-2xl font-bold text-center">
                            {msg || "Invalid Email Verification Link"}
                        </p>
                    </div>
                    <div className="flex gap-2 items-center mt-4 font-bold mb-8">
                        <button className="bg-brand-green text-white px-4 py-2 rounded-lg" onClick={() => window.location.href = '/'}>Go Home</button>
                    </div>
                </div>
            </div>
        </div>
    );
}